<template>
  <div>
    <!-- Bootstrap Modal -->
    <div class="modal fade" id="shareModal" tabindex="-1" aria-labelledby="shareModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="shareModalLabel">{{ shareText  }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="d-flex flex-column gap-3 align-items-center">
              <!-- WhatsApp Share -->
              <a :href="whatsAppShareUrl" target="_blank" class="share-btn whatsapp-btn">
                <i class="fab fa-whatsapp"></i> Share on WhatsApp
              </a>
              <!-- Twitter Share -->
              <a :href="twitterShareUrl" target="_blank" class="share-btn twitter-btn">
                <i class="fab fa-twitter"></i> Share on Twitter
              </a>
              <!-- Telegram Share -->
              <a :href="telegramShareUrl" target="_blank" class="share-btn telegram-btn">
                <i class="fab fa-telegram"></i> Share on Telegram
              </a>
              <!-- Copy Link -->
              <button class="share-btn copy-btn" @click="copyLink">
                <i class="fas fa-copy"></i> {{ copyButtonText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as bootstrap from 'bootstrap'

export default {
  name: 'ShareLink',
  props: {
    shareUrl: {
      type: String,
      required: true
    },
    shareText: {
      type: String,
      default: 'Check out this link!'
    }
  },
  data () {
    return {
      copyButtonText: 'Copy Link' // Text for copy button
    }
  },
  computed: {
    // WhatsApp share URL
    whatsAppShareUrl () {
      return `https://api.whatsapp.com/send?text=${encodeURIComponent(this.shareText + ' ' + this.shareUrl)}`
    },
    // Twitter share URL
    twitterShareUrl () {
      return `https://twitter.com/intent/tweet?text=${encodeURIComponent(this.shareText)}&url=${encodeURIComponent(this.shareUrl)}`
    },
    // Telegram share URL
    telegramShareUrl () {
      return `https://t.me/share/url?url=${encodeURIComponent(this.shareUrl)}&text=${encodeURIComponent(this.shareText)}`
    }
  },
  methods: {
    // Public method to open the share modal
    openShareModal () {
      const modalElement = document.getElementById('shareModal')
      const modal = new bootstrap.Modal(modalElement)
      this.copyButtonText = 'Copy Link' // Reset copy button text
      modal.show()
    },
    // Copy link to clipboard
    async copyLink () {
      try {
        await navigator.clipboard.writeText(this.shareUrl)
        this.copyButtonText = 'Link Copied!'
        setTimeout(() => {
          this.copyButtonText = 'Copy Link'
        }, 2000) // Reset text after 2 seconds
      } catch (err) {
        console.error('Failed to copy link: ', err)
        this.copyButtonText = 'Failed to Copy'
      }
    }
  }
}
</script>

<style scoped>
/* Clean UI for share buttons */
.share-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 250px;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  text-decoration: none;
  transition: transform 0.2s, box-shadow 0.2s;
  color: white;
}

.share-btn i {
  font-size: 1.5rem;
  margin-right: 10px;
}

.share-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

/* Platform-specific colors */
.whatsapp-btn {
  background-color: #25D366;
}
.whatsapp-btn:hover {
  background-color: #20b358;
}

.twitter-btn {
  background-color: #1DA1F2;
}
.twitter-btn:hover {
  background-color: #1991d8;
}

.telegram-btn {
  background-color: #0088cc;
}
.telegram-btn:hover {
  background-color: #0077b3;
}

.copy-btn {
  background-color: #6c757d;
  border: none;
}
.copy-btn:hover {
  background-color: #5a6268;
}

/* Modal body styling */
.modal-body {
  padding: 2rem;
}

.gap-3 {
  gap: 1rem;
}

.modal-content {
  border-radius: 12px;
  border: none;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  background-color: var(--bs-body-bg);
  margin: 20px;
  padding: 15px;
}

.modal-dialog-centered {
  min-height: 100vh;
  display: flex;
  align-items: center;
}

.modal {
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-header {
  border-bottom: none;
  padding-bottom: 0;
}

.modal-title {
  font-weight: 600;
  font-size: 1.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/report/ShareLink.vue